import React, {useState, useEffect} from "react";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import MuiAlert from "@mui/material/Alert";
import {Home, Wallet, List, Bell, Search, Menu, User} from "lucide-react";
import FeaturedInfo from "../../components/featuredInfo/FeaturedInfo";
import Arrears from "../../components/arrears/Arrears";
import Transactions from "../../components/transactions/Transactions";
import {loginState} from "../../dummyData";
import "./home.css";
import FeaturedInfoModern from "../../components/featuredInfo/FeaturedInfoModern";
import ArrearsModern from "../../components/arrears/ArrearsModern";
import TransactionsModern from "../../components/transactions/TransactionsModern";

export default function HomeModern(props) {
    // States
    const [backDrop, setBackDrop] = useState(<></>);
    const [updateSet] = useState(false);
    const [open, setOpen] = useState(loginState);
    const [message] = useState("");
    const [severity] = useState("success");
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeTab, setActiveTab] = useState("dashboard");

    // Handle snackbar close
    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    // Alert component
    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    // Toggle sidebar
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="dashboard-container" style={{
            display: 'flex',
            minHeight: '100vh',
            backgroundColor: '#f9fafb'
        }}>
            {/* Main content - Fixed to account for sidebar */}
            <div
                className="main-content"
                style={{
                    flex: 1,
                    // padding: '20px',
                    // No margin needed since Sidebar component handles the layout
                }}
            >
                {/* Page content */}
                <div className="page-content">
                    {/* Snackbar */}
                    {backDrop}
                    <Stack spacing={2} sx={{width: "100%"}}>
                        <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                            <Alert onClose={handleClose} severity={severity} sx={{width: "100%"}}>
                                {message}
                            </Alert>
                        </Snackbar>
                    </Stack>

                    {/* Dashboard widgets */}
                    <div className="dashboard-widgets" style={{
                        display: 'flex',
                        gap: '1.5rem',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                        flexDirection: 'column'
                    }}>
                        <div className="widget featured-info-widget" style={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '1.5rem',
                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #e5e7eb',
                            margin: '10px'
                        }}>
                            <h2 className="widget-title" style={{
                                fontSize: '1.125rem',
                                fontWeight: '600',
                                color: '#374151',
                                marginBottom: '1rem',
                                marginTop: 0
                            }}>
                                Account Summary
                            </h2>
                            <FeaturedInfoModern snackBar={props.snackBar}/>
                        </div>

                        <div className="widget arrears-widget" style={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '1.5rem',
                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #e5e7eb',
                            margin: '10px'
                        }}>
                            <h2 className="widget-title" style={{
                                fontSize: '1.125rem',
                                fontWeight: '600',
                                color: '#374151',
                                marginBottom: '1rem',
                                marginTop: 0
                            }}>
                                Arrears
                            </h2>
                            <ArrearsModern snackBar={props.snackBar}/>
                        </div>

                        <div className="widget transactions-widget" style={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '1.5rem',
                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #e5e7eb',
                            gridColumn: '1 / -1', // Full width for transactions
                            margin: '10px'
                        }}>
                            <h2 className="widget-title" style={{
                                fontSize: '1.125rem',
                                fontWeight: '600',
                                color: '#374151',
                                marginBottom: '1rem',
                                marginTop: 0
                            }}>
                                Recent Transactions
                            </h2>
                            <TransactionsModern snackBar={props.snackBar}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}